let filters = [
    {title: 'All', value: 'all'},
    {title: 'Assets', value: 'asset'},
    {title: 'Merchandise', value: 'campaign'},
    {title: 'Product', value: 'product'}
];
export default filters;
